import React from 'react';
import PropTypes from 'prop-types';

import Ratings from '@hpstellar/core/Ratings';
import Link from '@hpstellar/core/Link';
import Typography from '@hpstellar/core/Typography';
import Violator from '@hpstellar/core/Violator';

import withWindowResize from '../../ui/components/window-resize';
import ProductPriceBlock from '../../product/components/product-price/product-price-block';
import LazyLoadImage from '../../shared/components/lazyload-image';
import ProductCardHeader from '../../product/components/product-card-header';
import Icon from '../../ui/components/icon';
import PurchaseButton from '../../product/components/purchase-button-v2';

import './compare-box-detail.less';

function CompareBoxDetail({ product, toggleCompareProduct, width, readOnly }) {
    //TODO temp fix for inconsistent product API clean up props (imageUrl, name, salePrice, listPrice)
    const {
        usageLabel = [],
        images,
        productType,
        title,
        configName,
        icon,
        price,
        productUrl,
        rating,
        imageUrl,
        salePrice,
        listPrice,
        name,
    } = product;

    const score = product.rating?.score || product.rating;
    const [firstImage] = images;

    return (
        <div className="compare-box detail v2" large={2}>
            <div className="header">
                {!readOnly && (
                    <span className="positioner">
                        <span className="action" onClick={() => toggleCompareProduct(product)}>
                            <Icon name="x" size={16} />
                        </span>
                    </span>
                )}
                <ProductCardHeader product={product} saleCalloutPath="violatorMsg" />
                <span className="usageLabelContainer">
                    {usageLabel.map((label, i) => (
                        <Violator key={`usage_${i}`} size="small" value={label} />
                    ))}
                </span>
            </div>

            <LazyLoadImage height={200} once offset={400} src={firstImage?.src || imageUrl} />
            {configName && (
                <div className="config-name">
                    {icon && <LazyLoadImage height={200} once offset={400} src={icon} />}
                    <Typography tag="span" variant="headingSubheader">
                        {configName || name}
                    </Typography>
                </div>
            )}
            {typeof score !== 'undefined' && (
                <Ratings className="ratings" score={score} reviewsCount={rating?.reviewsCount} size="large" />
            )}
            <span className="badge">
                {productType && (
                    <Violator className="customizable" variation="product" size="small" value={productType} />
                )}
            </span>
            <span className="productName">{title || name}</span>
            <ProductPriceBlock
                size={width <= 768 ? 'small' : 'medium'}
                product={product}
                price={(title && price) || { salePrice, regularPrice: listPrice }}
            />
            <Link
                className="seeMoreLink"
                aria-label="See more"
                href={productUrl}
                preventDefault
                target="_blank"
                variation="primary"
            >
                See more
            </Link>
            <PurchaseButton size="small" product={product} isV2 />
        </div>
    );
}

CompareBoxDetail.propsTypes = {
    /** product object */
    product: PropTypes.object,
    /** add/remove product from compare set */
    toggleCompareProduct: PropTypes.func,
};

export default withWindowResize(CompareBoxDetail);
